export interface MulticardUrlResolution {
  type: 'product_base' | 'multicard_group';
  canonical_path: string;
  product_id?: number;
  selected_offer_id: number | null;
  redirect_path: string | null;
}

export function isMulticardGroupPath(path: string) {
  return /^\/catalog\/.+\/\d+\/?$/.test(path);
}

export function appendQueryParameters(path: string, searchParams: URLSearchParams) {
  const targetUrl = new URL(path, 'https://wtfish.ru');

  for (const [key, value] of searchParams.entries()) {
    if (key !== 'offer_id') targetUrl.searchParams.append(key, value);
  }

  return `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`;
}

export function getMulticardRedirectLocation(resolution: MulticardUrlResolution, searchParams: URLSearchParams) {
  if (!resolution.redirect_path) return null;

  return appendQueryParameters(resolution.redirect_path, searchParams);
}

export function getMulticardCanonicalPath(path: string, resolution: MulticardUrlResolution | null | undefined) {
  return resolution?.canonical_path ?? path;
}
